import { useFormContext } from "src/lib/templates";
import { PaymentCancelation } from "src/app/models";

export const useRegretFormContext = () => useFormContext<PaymentCancelation>();
